import React, { FC, useState, useEffect, useCallback } from "react";
import { NavLink, useLocation, useNavigate, useParams } from "react-router-dom";
import { Link, Box, IconButton, Button } from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';
import EmailIcon from '@mui/icons-material/EmailOutlined';
import CloseIcon from '@mui/icons-material/Close';
import { atom, useAtom } from "jotai";

// common
import { debounce, classList } from "@util/scroll-tools";
import { ActionCB } from "@common/type_defs";
import { defs } from "@common/const_defs";
import { dic } from "@common/text_defs";
import NoneWrapper from "@cmpt/atoms/NoneWrapper";
import { scrollTo, scrollToQuery } from "@util/scroll-tools";

const atomScrollHandler = atom<Record<string, any>>({});
const atomIsBarFloat = atom<boolean>(true);
const TopBar: FC<{ onAction: ActionCB }> = ({ onAction }) => {
  const [dicScrollHandler, setScrollHandler] = useAtom(atomScrollHandler)
  const [isTop, setIsTop] = useAtom(atomIsBarFloat);
  const [isBarClosed, setBarClosed] = useState(true);
  const [mainContainer, setMainContainer] = useState<any>(null);
  const location = useLocation()
  const navigate = useNavigate();

  useEffect(() => {
    const fn = setTimeout(() => {
      let mainContainer: any = document.querySelector("#main-content");
      setMainContainer(mainContainer);
    }, 200);
    return () => {
      clearTimeout(fn);
    }
  }, [])

  let handleScrollRef: any = null;

  const handleScroll = () => {
    return debounce(({ target: { scrollTop } }: any) => {
      let isCurrentTop = scrollTop < 100 || mainContainer.scrollY < 100;
      setIsTop(isCurrentTop);
    }, 20);
  };

  handleScrollRef = handleScroll();

  const handleScrolled = () => {
    setBarClosed(true);
  };

  useEffect(() => {
    if (mainContainer) {
      mainContainer.addEventListener("scroll", handleScrollRef);
    }

    return () => {
      if (mainContainer) {
        mainContainer.removeEventListener("scroll", handleScrollRef);
      }
    };
  }, [mainContainer, handleScrollRef]);

  const handleJump = (page: string, archor: string, e: any) => {
    if (location.pathname === page) {
      scrollToQuery("#main-content", archor)
    } else {
      navigate(page, { state: { archor } })
    }
    e.preventDefault();
    handleScrolled();
  }

  return (
    <Box component="section"
      className={classList({
        header: true,
        "header-fixed": !isTop,
        closed: isBarClosed,
      })}
    >
      <Box component="div" className="container header-container">
        <Box component="div" className="brand" sx={{}}>
          <a href="/" ><img src="./assets/images/logo5.png" alt="" /></a>
        </Box>
        <Box component="ul" className="navigation">
          <Box component="li">
            <Link href="##" onClick={(e) => handleJump('/home', 'intro', e)}>
              {dic.menu.home}
            </Link>
          </Box>
          <Box component="li">
            <Link href="##" onClick={(e) => handleJump('/home', 'service', e)}>
              {dic.menu.services}
            </Link>
          </Box>
          <Box component="li">
            <Link href="##" onClick={(e) => handleJump('/home', 'ability', e)}>
              {dic.menu.ability}
            </Link>
          </Box>
          <Box component="li">
            <Link href="##" onClick={(e) => handleJump('/home', 'works', e)}>
              {dic.menu.works}
            </Link>
          </Box>
          <Box component="li">
            <Link href="/company">
              {dic.menu.company}
            </Link>
          </Box>
        </Box>
        <Box sx={{ flexGrow: 1 }} />
        <Button variant="outlined"
          className="btn_info"
          sx={{
            fontWeight: 600,
            color: "#606060",
            "&:hover": {
              bgcolor: "#ffffff",
              color: "#e03000",
              boxShadow: "0 5px 15px rgba(0, 0, 0, 0.4)",
              fontWeight: 600
            }
          }}
        >
          <EmailIcon sx={{ fontSize: 20, }} />
          <Box component="a" href={`/contact`} sx={{ ml: '5px', fontSize: '14px', }}>
            {dic.menu.contact}
          </Box>
        </Button>
        {/* <div className="navigation flex">
          <NavLink to="/login" className="mr-1">
            <Button
              className="box-shadow-none px-8 rounded-l hover-bg-primary capitalize"
              variant="outlined"
              color="primary"
            >
              Login
            </Button>
          </NavLink>
          <NavLink to="/signup">
            <Button
              className="box-shadow-none px-8 rounded-r hover-bg-primary capitalize"
              variant="outlined"
              color="primary"
            >
              Signup
            </Button>
          </NavLink>
        </div> */}
        <IconButton
          className="header__toggle"
          onClick={() => {
            setBarClosed(!isBarClosed);
          }}
        >
          <NoneWrapper show={isBarClosed}><MenuIcon sx={{ pt: '5px', width: 40, height: 32 }} /></NoneWrapper>
          <NoneWrapper show={!isBarClosed}><CloseIcon sx={{ pt: '2px', width: 36, height: 30 }} /></NoneWrapper>
        </IconButton>
      </Box>
    </Box>
  );
};

export default TopBar;
export { atomIsBarFloat, atomScrollHandler, TopBar }
